<template>
  <Card>
    <template #content>
      <div class="grid-container">
        <div class="type">
          <CashFlowTypeTag :transaction="transaction"></CashFlowTypeTag>
        </div>
        <div class="category card-field">
          <span>
            <IconCategory></IconCategory>
          </span>
          <p>
            {{ transaction?.category?.name || '-' }}
          </p>
        </div>
        <div class="farm card-field">
          <span class="material-icons">map</span>
          <p
            class="text-field-overflow"
            v-tooltip.top="transaction?.farm?.name || ''"
          >
            {{ transaction?.farm?.name || '-' }}
          </p>
        </div>
        <div class="card-field responsible">
          <span class="material-icons">person</span>
          <p
            class="text-field-overflow"
            v-tooltip.top="transaction.responsibleName || ''"
          >
            {{ transaction.responsibleName || '-' }}
          </p>
        </div>
        <div class="card-field other-account">
          <span class="material-icons" style="color: #396DF4">assignment_ind</span>
          <p>
            {{ transaction?.customer?.name || transaction?.vet?.name || '-' }}
          </p>
        </div>
        <div class="card-field tags">
          <span
            class="card-tag"
            v-for="(tag, index) in transaction.tags"
            :key="index"
          >
            <AppTag :text="tag.tag.name"></AppTag>
          </span>
        </div>
        <div class="card-field name">
          <p>{{ transaction.name || '-' }}</p>
        </div>
        <div class="card-field value">
          <span class="material-icons">attach_money</span>
          <p>{{ $toDecimal(transaction.value) }}</p>
        </div>
        <div class="card-field date">
          <span class="material-icons">event</span>
          <p>
            {{
              transaction.date
                ? $dayjs(transaction.date).format('DD/MM/YYYY')
                : '-'
            }}
          </p>
        </div>
        <div class="card-field attachment">
          <span><IconAttachment></IconAttachment></span>
          <p>{{ transaction.attachments.length || '-' }}</p>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import IconAttachment from '../../../components/icon/IconAttachment.vue';
import IconCategory from '../../../components/icon/IconCategory.vue';
import CashFlowTypeTag from './CashFlowTypeTag.vue';

export default {
  name: 'CashFlowCard',
  props: {
    transaction: Object,
  },
  components: {
    CashFlowTypeTag,
    IconCategory,
    IconAttachment,
  },
};
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(5, 1fr);
  gap: 0.5em 1em;
  grid-template-areas:
    'type category'
    'name value'
    'farm date'
    'responsible attachment'
    'other-account tags';
}

.text-field-overflow {
  max-width: 150px;
}

@media (min-width: 600px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 1fr);
    gap: 0.5em 1em;
    grid-template-areas:
      'type category name'
      'value farm date'
      'responsible attachment other-account'
      'tags tags tags';
  }
}

@media (min-width: 960px) {
  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 0.5em 1em;
    grid-template-areas:
      'type category farm responsible other-account'
      'name value date attachment tags';
  }

  .text-field-overflow {
    max-width: unset;
  }
}

.type {
  grid-area: type;
}

.category {
  grid-area: category;
}

.farm {
  grid-area: farm;
}

.responsible {
  grid-area: responsible;
}

.tags {
  grid-area: tags;
}

.name {
  grid-area: name;
}

.value {
  grid-area: value;
}

.date {
  grid-area: date;
}

.attachment {
  grid-area: attachment;
}

.other-account {
  grid-area: other-account;
}

/* Content */
div >>> .p-card-content {
  padding: 0 !important;
}

.card-field p {
  display: inline-block;
  vertical-align: top;
  padding-top: 2px;
}

.card-field span {
  padding-right: 10px;
}

.card-tag {
  padding: 0 5px 5px 0;
  height: fit-content;
}

.tags {
  display: flex;
  flex-flow: row wrap;
  align-content: flex-start;
}
</style>